import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types";

interface NewsItemProps {
  news: NewsArticle;
  variant?: "list" | "card";
}

export default function NewsItem({ news, variant = "list" }: NewsItemProps) {
  if (variant === "card") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
      >
        <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} - 爱爱网影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="p-4">
          <div className="flex items-center gap-2 mb-2 flex-wrap">
            <span className="px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-[11px] font-medium">
              {news.tags[0]}
            </span>
            <span className="text-xs text-foreground-400">{news.date}</span>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{news.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex gap-4 py-4 border-b border-background-200 last:border-0 cursor-pointer"
    >
      <div className="shrink-0 w-28 h-20 md:w-40 md:h-24 rounded-md overflow-hidden bg-background-200">
        <img
          src={news.cover}
          alt={news.title}
          title={`${news.title} - 爱爱网影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <p className="mt-1.5 hidden sm:block text-xs md:text-sm text-foreground-600 line-clamp-2">
          {news.summary}
        </p>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {news.date}
          </span>
          <span className="hidden sm:flex items-center gap-1">
            <i className="ri-price-tag-3-line" />
            {news.tags[0]}
          </span>
        </div>
      </div>
    </Link>
  );
}